import type { ReactNode } from 'react'

import * as styles from './app-bar.styles'

type Props = {
  children: ReactNode
  position?: keyof typeof styles.positions
}

export const AppBarActions = ({ position = 'left', children }: Props) => (
  <div
    css={[styles.actions, styles.positions[position]]}
    data-testid="app-bar-actions"
  >
    {children}
  </div>
)
